import React from 'react'
import {CSSTransitionGroup} from 'react-transition-group'
import '../stylesheets/WelcomeHeading.sass'
import Content from "../Contents.json"

class WelcomeHeading extends React.Component {

	constructor (props) {
		super(props)
		this.mainTime = 1000
		this.inbetweenTime = 600
		this.state = {
			animState: 0,
			language: props.language,
		}

		this.handleScroll = this.handleScroll.bind(this)

	}

	componentWillReceiveProps (props) {
		this.setState({language: props.language})
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
		clearInterval(this.animTimer)
	}

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll, true);
		this.animTimer = setInterval(this.updateAnim,this.mainTime)
	}

	updateAnim = () => {
		this.setState({animState: (this.state.animState + 1)})
		clearInterval(this.animTimer)
		if (this.state.animState > 6) {
			return
		}
		if (this.numberIsEven) {
			this.animTimer = setInterval(this.updateAnim,this.mainTime)
			return
		}
		this.animTimer = setInterval(this.updateAnim,this.inbetweenTime)
		return
	}

	numberIsEven (number) {
		if ((number % 2) === 0) {
			return true
		}
		return false
	}

	handleScroll () {
		clearInterval(this.animTimer)
		this.setState({animState: 7})
	}

		render () {

		var content = this.state.language === "de" ? Content.de.welcomeheading : Content.en.welcomeheading

		let body 

		var body0 = (<div key="hoho" className="welcomeHeading">
					 <h1>{content[0]}</h1>	
					</div>)

		var body1 = (<div key="markus" className="welcomeHeading">
					  <h2>{content[1][0]}</h2>
					  <h3>{content[1][1]}</h3>
					 </div>)
		var body2 = (<div key="jojo" className="welcomeHeading">
					  <h2>{content[2][0]}</h2>
					  <h3>{content[2][1]}</h3>
					 </div>)
		var body3 = (<div key="Whynot!" className="welcomeHeading final">
					  <h1>{content[3][0]}</h1>
					  <h3>{content[3][1]}</h3>
					 </div>)

		var discoverButton = (<div key="discover" className="discover">
							   <h2 className="Text">{content[4]}</h2>
							   <svg className="Button hovering" xmlns="http://www.w3.org/2000/svg" width="100" height="50">
								<line x1="0"  y1="0" x2="60%" y2="100%"/>
								<line x1="100%"  y1="0" x2="40%" y2="100%"/>
							   </svg>
							  </div>)

		var bodyMain = [body3,discoverButton]

		console.log(this.state.animState)

		switch (this.state.animState) {
			case 0:
				body = body0
				break
			case 1:
				body = ""
				break
			case 2:
				body = body1
				break
			case 3: 
				body = ""
				break
			case 4:
				body = body2
				break
			case 5:
				body = ""
				break
			case 6:
				body = body3
				break
			default:
				body = bodyMain
				break

		}

		return (<div className="welcomeContainer" style={{backgroundPosition: this.state.backgroundPosition}}>
			<CSSTransitionGroup
					transitionName="fade"
					transitionAppear={true}
					transitionAppearTimeout={300}
			    	transitionEnterTimeout={300}
			    	transitionLeaveTimeout={300}>
					{body}
				</CSSTransitionGroup></div>)
	}
}

export default WelcomeHeading